import React, { Component } from "react";
import { connect } from "react-redux";
import { showSocialMediaBlast } from "../../store/ducks/socialMediaBlast/actions";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import { withNamespaces } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import DomPurify from "../../components/Sanitize/DomPurify";

class SocialMediaBlastShow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            members: []
        };
    }

    componentDidMount() {
        this.props.showSocialMediaBlast(this.props.socialMediaBlastId);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("[EmailContentShow] shouldComponentUpdate()", "\nnextProps: ",nextProps, "\nnextState: ",nextState);
        if (nextProps.show !== undefined && nextProps.show !== this.props.show && nextState.loading === true) {
            let memberData = JSON.parse(nextProps.show.data.member_id);
            this.setState({
                loading: false,
                members: memberData
            });
        }
        return true;
    }

    render() {
        const { t } = this.props;
        let display = null;
        if (!this.state.loading) {
            let socialMediaBlastData = this.props.show.data;
            display = (
                <div className="row row-sm">
                    <div className="col-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("social-media-blast.social-media-blast-details")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <table className="table table-bordered table-striped">
                                    <tbody>
                                        <tr>
                                            <th>{t("social-media-blast.start-time")}</th>
                                            <td field-key="start_time">{socialMediaBlastData.start_time}</td>
                                        </tr>
                                        <tr>
                                            <th>{t("social-media-blast.image")}</th>
                                            <td field-key="title">
                                            <img
                                                alt=""
                                                className="show-banner-size"
                                                src={socialMediaBlastData.image_url}
                                            />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("social-media-blast.details")}</th>
                                            <td field-key="content" className="email-content">
                                                {/* <textarea className="form-control" defaultValue={emailContentData.content} cols="120" rows="20" disabled></textarea> */}
                                                {/* <span dangerouslySetInnerHTML={{ __html: emailContentData.content }} /> */}
                                                <DomPurify text={socialMediaBlastData.details} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("social-media-blast.members")}</th>
                                            <td field-key="content" className="email-content">
                                                
                                               {this.state.members.map(function(val, index) {
                                                    return <li>{val.label}</li>
                                               })}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            display = (
                <div className="row row-sm">
                    <div className="col-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("social-media-blast.social-media-blast-details")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <Skeleton count={4} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("email-content.email-content")}</h4>
                        </div>
                    </div>
                </div>
                {display}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    const { socialMediaBlast } = state;

    return {
        show: socialMediaBlast.show,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showSocialMediaBlast: (id) => dispatch(showSocialMediaBlast(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(SocialMediaBlastShow));
